import { useMemo } from 'react'
import { useSelector as useReactReduxSelector, useDispatch } from 'react-redux'

// Re-export useDispatch from the project-standard hook module so all hook
// imports can come from 'hooks/redux' consistently, matching the pattern
// established by useSelector below.
export { useDispatch }

export const useSelector = (selector, props) =>
  useReactReduxSelector((state) => selector(state, props))

export const useMakeSelector = (makeSelector, props) => {
  const selector = useMemo(makeSelector, [])
  return useReactReduxSelector((state) => selector(state, props))
}
